import { React, Fragment, useState, useEffect, useCallback } from "react";
import { TitleBar, Header } from "webapp/components";

import { useTranslation } from "react-i18next";

import "bootstrap/dist/css/bootstrap.min.css";
import nextIcon from "assets/icons/carat-r-white.png";
import "./TrxNowLocateUser.scss";
import { CancelOutlined, PropaneSharp } from "@mui/icons-material";
import TrxNowGoogleMap from "webapp/components/TrxNowMap/TrxNowGoogleMap";
import { AppState } from "webapp/enums/AppState";
import { useRef } from "react";
import Modal from "react-responsive-modal";
import { Alert, CircularProgress } from "@mui/material";
import { AddressAutoComplete } from "webapp/components/AddressAutoComplete";
import { ReverseGeoCode } from "utils/here-maps/hereHttpRequest";
import { devLog } from "utils/devLog";

import LocationOffIcon from "@mui/icons-material/LocationOff";
import {
  apiGetAutocompleteList,
  apiRevGeocodeLocationGoogle,
  apiRevGeocodeLocationGoogleList,
} from "utils/API/TrxNowAPI";

/**
 */
export default function TrxNowLocateUser(props) {
  const { t } = useTranslation();

  const titleBarRef = useRef(null);
  const footerRef = useRef(null);
  const headerRef = useRef(null);

  const [addressInput, setAddressInput] = useState("");
  const [currentLocation, setCurrentLocation] = useState(props.disablementCoords);
  const [onHighway, setOnHighway] = useState("");

  const [isHomeScreen, setIsHomeScreen] = useState(false);
  // const [screenType, setScreenType] = useState(window.screen.orientation.type);
  const [mapHeight, setMapHeight] = useState(400);
  const rotateTimeout = useRef(null);
  const [showSpinner, setShowSpinner] = useState(true);
  const [loading, setLoading] = useState(true);

  const [geoLocationStatus, setGeoLocationStatus] = useState(props.geoLocationStatus);
  const [locationList, setLocationList] = useState([]);
  const [locationHistory, setLocationHistory] = useState([]);

  const [data, setData] = useState({});
  const [currZoom, setCurrZoom] = useState(17);
  const [displayAutoCompleteList, setDisplayAutoCompleteList] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);
  const [addressSelected, setAddressSelected] = useState(false);

  const [addressComplete, setAddressComplete] = useState(true);
  const street = props.currState.DisablementStreet;
  const city = props.currState.DisablementCity;
  const state = props.currState.DisablementState;
  const country = props.currState.DisablementCountry;
  const zip = props.currState.DisablementZip;

  let bHasStreet = false;
  let bHasCity = false;
  let bHasState = false;
  let bHasCountry = false;
  let bHasZip = false;

  const checkAddressCompletion = () => {
    devLog("zip", zip.length > 0);
    if (street.length > 0) {
      bHasStreet = true;
    }
    if (city.length > 0) {
      bHasCity = true;
    }
    if (state.length > 0) {
      bHasState = true;
    }
    if (country.length > 0) {
      bHasCountry = true;
    }
    if (zip.length > 0) {
      bHasZip = true;
    }
    return bHasStreet && bHasCity && bHasState && bHasCountry && bHasZip;
  };

  const LocateUserObj = {
    img: props.logo,
    partner: props.currState.partner,
    fragment: (
      <Fragment>
        <p className="mb-0">
          <strong>{t("description.LocateUserTitleBar1")}</strong>
          <br />
          <span className="alt-text-main">{t("description.LocateUserTitleBar2")}</span>
        </p>
      </Fragment>
    ),
  };

  const updateMapHeight = () => {
    let offset = 0;

    if (titleBarRef.current) {
      offset += titleBarRef.current.clientHeight;
    }

    if (headerRef.current) {
      offset += headerRef.current.clientHeight;
    }

    if (footerRef.current) {
      offset += footerRef.current.clientHeight;
    }

    if (window?.screen?.orientation?.angle == 90) {
      // setScreenType(window.screen.orientation.type);
      setMapHeight(window.innerHeight - 50);
    } else {
      devLog("offset", offset, titleBarRef.current, headerRef.current, footerRef.current);
      // setScreenType(window.screen.orientation.type);
      setMapHeight(window.innerHeight - offset);
    }
    devLog("map height: " + mapHeight);
  };

  const onWindowResize = (e) => {
    updateMapHeight();

    clearTimeout(rotateTimeout.current);
    rotateTimeout.current = setTimeout(() => {
      updateMapHeight();
    }, 200);
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
    setShowSpinner(geoLocationStatus === "PENDING");
    setLoading(geoLocationStatus === "PENDING");

    const bIsHomeScreen = !!props.currState.navigationService.getState(AppState.LocateUser).params?.isHomeScreen;

    setIsHomeScreen(bIsHomeScreen);
    // setScreenType(window.screen.orientation.type);
    onWindowResize();

    // devLog("screenType: ", window.screen.orientation.type);
    devLog("Home page or not: ", bIsHomeScreen);
    window.addEventListener("resize", onWindowResize);
    return () => {
      window.removeEventListener("resize", onWindowResize);
    };
  }, []);

  useEffect(() => {
    devLog("geoLocationStatus", props.geoLocationStatus);
    setGeoLocationStatus(props.geoLocationStatus);
    setTimeout(() => {
      setShowSpinner(props.geoLocationStatus === "PENDING");
      setLoading(props.geoLocationStatus === "PENDING");
    }, 500);
  }, [props.geoLocationStatus]);

  const onUserBack = () => {
    if (typeof props.onUserBack === "function") {
      props.onUserBack();
    }
  };

  useEffect(() => {
    devLog("Disablement Coords are now:", props.disablementCoords);
    setCurrentLocation(props.disablementCoords);
    setAddressInput(props.addressLabel || "");
  }, [props.disablementCoords, props.addressLabel]);

  const onAddressSelectedChange = (isSelected) => {
    devLog("onAddressSelectedChange:", isSelected);
    setAddressSelected(isSelected);
    setData({ ...data, addressSelected: isSelected });
  };

  const onUserNext = () => {
    setAddressComplete(true);
    let check = checkAddressCompletion();
    devLog("onUserNext addressSelected: ", addressSelected);
    if (check) {
      if (typeof props.onUserNext === "function") {
        setAddressComplete(true);
        devLog("valid address", check, addressComplete);
        devLog("valid address data", data);
        props.onUserNext(data);
      }
    } else {
      setAddressComplete(false);
      devLog("invalid address", check, addressComplete);
      return;
    }
  };

  const onLocationUpdate = (coords, locationData) => {
    devLog("onLocationUpdate:", coords, locationData);
    setShowSpinner(false);
    setLoading(false);
  };

  const zoomChange = (newZoom) => {
    setCurrZoom(newZoom);
  };

  const getLocationList = (address, coords) => {
    if (address && coords) {
      apiGetAutocompleteList(address, coords.lat, coords.lng, (locationsList) => {
        if (typeof locationsList !== "object" || !Array.isArray(locationsList.results)) {
          setLocationList([]);
          return;
        }
        setLocationList(locationsList.results);
      });
    } else {
      setLocationList([]);
      return;
    }
  };

  const onMarkerDragEnd = useCallback((newCoords) => {
    devLog("Maker Dragger: ", newCoords);
    setCurrentLocation(newCoords);
    setLoading(true);
    apiRevGeocodeLocationGoogleList({ lat: newCoords.lat, lng: newCoords.lng }, (addressResult) => {
      devLog("apiRevGeocodeLocationGoogleList Address Result: ", addressResult);
      if (addressResult.length === 1) {
        setAddressInput(addressResult[0].address.label);
        setLocationList([]);
        setLoading(false);
      } else {
        setAddressInput("");
        setLoading(false);
        setLocationList(addressResult);
      }
    });
    // apiRevGeocodeLocationGoogle({ lat: newCoords.lat, lng: newCoords.lng }, (addressResult) => {
    //   devLog("Reverse Geo Code Address Result: ", addressResult);
    //   setLoading(false);
    //   setAddressInput(addressResult.address.label);
    // });
  }, []);

  const onDisplayAutoCompleteList = useCallback((data) => {
    devLog("TrxNow Locate User onDisplayAutoCompleteList:", data);
    setDisplayAutoCompleteList(data);
  }, []);

  const handleOnHighwayChange = (value) => {
    devLog("handleOnHighwayChange:", value);
    setOnHighway(value);
    setData({ ...data, onHighway: value });
  };

  const handleLocationUpdate = (coords, locationData, addressSelected) => {
    devLog("onLocationUpdate:", coords, locationData, addressSelected);
    setAddressSelected(addressSelected);
    if (typeof props.onLocationUpdate === "function") {
      props.onLocationUpdate(coords, locationData);
    }
    onLocationUpdate(coords, locationData);
    setShowSpinner(false);
    setLoading(false);
  };

  return (
    <>
      <AddressAutoComplete
        handleOnHighwayChange={handleOnHighwayChange}
        onHighway={onHighway}
        addressInput={addressInput}
        zoomChange={zoomChange}
        setShowOverlay={setShowOverlay}
        getLocationList={getLocationList}
        locationList={locationList}
        currentLocation={currentLocation}
        onLocationUpdate={handleLocationUpdate}
        addressComplete={addressComplete}
        displayAutoCompleteList={displayAutoCompleteList}
        onDisplayAutoCompleteList={onDisplayAutoCompleteList}
        onAddressSelectedChange={onAddressSelectedChange}
      />

      {(showSpinner || loading) && (
        <Modal
          open={true}
          onClose={() => {}}
          closeOnEsc={false}
          center={true}
          closeOnOverlayClick={false}
          showCloseIcon={false}
        >
          <CircularProgress disableShrink />
        </Modal>
      )}

      <div>
        {!loading || !showSpinner ? (
          <TrxNowGoogleMap
            loading={loading}
            showOverlay={showOverlay}
            setShowOverlay={setShowOverlay}
            disablementCoords={currentLocation}
            //destinationCoords={{ lat: 36.339126, lng: -82.351134 }}
            height={mapHeight}
            zoom={currZoom}
            onZoomChange={(newZoom) => {
              zoomChange(newZoom);
            }}
            onMarkerDragEnd={onMarkerDragEnd}
            onDisplayAutoCompleteList={onDisplayAutoCompleteList}
            // markers={this.state.locationCoordsList}
          />
        ) : (
          <div style={{ height: mapHeight, backgroundColor: "white" }}></div>
        )}
      </div>

      {!isHomeScreen && (
        <div ref={headerRef}>
          <Header
            currState={props.currState}
            onUserBack={onUserBack}
            information={t("description.DisablementHeader1")}
          />
        </div>
      )}
      {props.currState.localGroup === "PBFL" && (
        <div ref={titleBarRef}>
          <TitleBar data={LocateUserObj} />
        </div>
      )}

      <div className="footerContainer" ref={footerRef}>
        <button
          id="cancelButton"
          type="button"
          className="footer locateUserFooterBtn"
          style={{ background: "#f4f4f4", color: "black", paddingLeft: 14 }}
          onClick={() => {
            devLog("UI Cancel pressed");
            if (typeof props.onUserCancel === "function") {
              props.onUserCancel();
            }
          }}
        >
          <CancelOutlined style={{ width: 20, color: "black", marginRight: 4 }} />
          <span style={{ marginLeft: "0px" }}>{t("description.CancelCallButton1")}</span>
        </button>

        <button
          type="hidden"
          id="tapForRoadside"
          className="footer locateUserFooterBtn"
          onClick={() => {
            onUserNext();
          }}
        >
          <span style={{ marginLeft: "0px" }}>{t("description.LocateUserButton1")}</span>
          <img src={nextIcon} alt="chevron" />
          <ion-icon
            name="chevron-forward-outline"
            role="img"
            class="md hydrated"
            style={{ fontSize: "40px" }}
            aria-label="chevron forward outline"
          />
        </button>
      </div>
    </>
  );
}
